export default __webpack_public_path__ + "static/media/tutorialWeb-3.8.91af44e2.png";